import { httpRequest } from '../../shared/lib/utils/httpClient';
const Voycekey = import.meta.env.VITE_VOYCE_KEY;
export interface LanguageLsitType {
  LanguageList: Language[];
  Successful: boolean;
  Reason: string;
}
export interface Language {
  LanguageId: number;
  LanguageName: string;
  LanguageNativeName: string;
}
export interface TransformedLanguage {
  id: number;
  name: string;
}
export interface InviteInterpreterType {
  LanguageId: number | string;
  MeetingId: number;
  URL: string;
}

export interface StatusType {
  Status: string;
  StatusCodeId: number;
  Reason: string;
  EstimationTimeString: string;
  Successful: boolean;
  InterpreterName: string;
}
export interface VoyceResponseType {
  Reason: string;
  RequestId: number;
  Successful: boolean;
}

export interface InterpreterHistoryProps {
  consultId: number;
  language: string;
  message: string;
  actionFlag: boolean;
}

export const getLanguage = async () => {
  const response = await httpRequest<LanguageLsitType>({
    url: '/Language/list',
    method: 'GET',
    headers: {
      VOYCEToken: Voycekey,
    },
    apiBaseType: 'VOYCE',
  });

  return response;
};

export const getStatus = async (id: string) => {
  const response = await httpRequest<StatusType>({
    url: `/Request/Status?RequestId=${id}`,
    method: 'GET',
    headers: {
      VOYCEToken: Voycekey,
    },
    apiBaseType: 'VOYCE',
  });

  return response;
};

export const InviteInterpreter = async (data: InviteInterpreterType) => {
  const response = await httpRequest<VoyceResponseType>({
    url: '/Request/New',
    method: 'POST',
    headers: {
      VOYCEToken: Voycekey,
    },
    apiBaseType: 'VOYCE',
    data: data,
  });

  return response;
};

export const SaveVoyceId = async (saveData: {
  voyceId: number;
  caseId: number;
  userId: number;
}) => {
  const response = await httpRequest({
    url: `/clinical/consult/${saveData.caseId}/interpreter?voyceId=${saveData.voyceId}`,
    method: 'PUT',
    headers: {
      userId: saveData.userId.toString(),
    },
  });

  return response;
};

export const InterpreterHistory = async (
  userId: number,
  data: InterpreterHistoryProps
): Promise<InterpreterHistoryProps> => {
  const response = await httpRequest<InterpreterHistoryProps>({
    url: `/clinical/consult/interpreter-history`,
    method: 'PUT',
    data,
    headers: {
      userId: userId.toString(),
    },
  });

  return response;
};
